import styled from '@emotion/styled'

import { Color } from '../../enums/color'
import { DefaultValue } from '../../enums/defaultValue'
import { Spacing } from '../../enums/spacing'

export const SettingsLayoutWrapper = styled.div`
  width: 100%;
  max-width: ${DefaultValue.ContainerWidth};
  margin: 0 auto;
  padding: ${Spacing.S32} ${Spacing.S40};
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
  position: relative;
  background-color: ${Color.White};
`

interface ChildrenWrapperProps {
  twoColumns?: boolean
}

export const Row = styled.div<ChildrenWrapperProps>`
  display: flex;
  gap: ${Spacing.S40};
`

export const Column = styled.div`
  width: 50%;
  height: fit-content;
`
